import { NextPageContext } from "next";
import List from "./autosusados";
import Layout from "../components/Layout";
import { addApolloState, initializeApollo } from "../graphql/client";
import { GET_USER } from "../graphql/queries/user";
import { SLUGS_METADATA, TIER_KEYS } from "../utils/constants";

export default function UserPage({ query, user, slug }) {
  return <List query={query} watchedUser={user} slug={slug} />;
}

UserPage.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};

export const getServerSideProps = async (context: NextPageContext) => {
  const { query } = context;
  const apolloClient = initializeApollo();

  try {
    const { slug } = query;

    if (slug) {
      const slugMetadata = SLUGS_METADATA.find(
        (slugObj) => slugObj.id === slug
      );

      const { data } =
        !slugMetadata || slug === TIER_KEYS.COLLECTION
          ? await apolloClient.query({
              query: GET_USER,
              variables: { username: slug },
            })
          : { data: null };

      const { getUser: user } = data || { getUser: null };

      if (!user && !slugMetadata) {
        return {
          redirect: {
            permanent: false,
            query,
            destination: "/autosusados",
          },
        };
      }

      return addApolloState(apolloClient, {
        props: {
          query,
          user,
          slug: user ? user.username : slug,
        },
      });
    } else {
      return {
        redirect: {
          permanent: false,
          query,
          destination: "/autosusados",
        },
      };
    }
  } catch (e) {
    return {
      redirect: {
        permanent: false,
        destination: "/",
      },
    };
  }
};
